import type { QueryHostListingsResponse } from '@wix/ambassador-os-backoffice-v1-host-listing/types';
import { HostListing } from './host-listing';

export class HostListings {
  constructor(private readonly response: QueryHostListingsResponse) {}

  current(): HostListing {
    return new HostListing(this.response.hostListings?.[0]);
  }

  get enabledPackageIds(): Set<string> {
    return this.current().enabledPackageIds;
  }
}
